// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__CV-nx","header":"styles_header__55q-J","body":"styles_body__0a1nR","bodyInp":"styles_bodyInp__j10kM"};